<template>
  <TTabsToggle
    :header="$t('forms.settings_element_spacer')"
    no-move
    :changed="wasChanged"
    data-testid="spacer-settings"
  >
    <menu-content-container :padding-left-right="8">
      <content-row class="!block">
        <t-input-number
          v-model="height.model"
          data-testid="spacer-height"
          unit=""
          :label="$t('forms.spacer_height')"
          :max="300"
          :min="5"
          :changed="height.changed"
          :reset-tooltip="$t('forms.reset_value')"
          flex
          @reset="height.reset"
        ></t-input-number>
      </content-row>
      <content-row class="!items-end">
        <color-picker
          :label="$t('forms.section_bgc')"
          data-testid="spacer-bg-color"
          position="left"
          :default-color="containerBgColor.model"
          :changed="containerBgColor.changed"
          :reset-tooltip="$t('forms.reset_value')"
          @color-change="containerBgColor.model = $event"
          @reset="containerBgColor.reset"
        ></color-picker>
        <TButton
          v-if="!containerGradient.model"
          data-testid="add-gradient"
          @click="
            containerGradient.model =
              'linear-gradient(90deg, #ff7e5f 0%, #feb47b 100%)'
          "
        >
          <template #icon>
            <svg
              width="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.958 3C20.3669 3 20.7597 3.16205 21.0488 3.45117C21.3379 3.74029 21.5 4.13312 21.5 4.54199V19.958C21.5 20.3669 21.3379 20.7597 21.0488 21.0488C20.7597 21.3379 20.3669 21.5 19.958 21.5H4.54199C4.13312 21.5 3.74029 21.3379 3.45117 21.0488C3.16205 20.7597 3 20.3669 3 19.958V4.54199C3 4.13312 3.16205 3.74029 3.45117 3.45117C3.74029 3.16205 4.13312 3 4.54199 3H19.958ZM10.708 4.54199V7.625H7.625V10.708H10.708V13.792H7.625V16.875H10.708V19.958H13.792V16.875H16.875V19.958H19.958V4.54199H16.875V7.625H13.792V4.54199H10.708ZM13.792 16.875H10.708V13.792H13.792V16.875ZM16.875 13.792H13.792V10.708H16.875V13.792ZM13.792 10.708H10.708V7.625H13.792V10.708Z"
                fill="currentColor"
              />
            </svg>
          </template>
          {{ $t("forms.add_gradient") }}
        </TButton>
      </content-row>
      <content-row class="!block" data-testid="gradient-form">
        <TTabsToggle
          v-if="containerGradient.model"
          :header="$t('forms.gradient')"
          :changed="containerGradient.changed"
          default-open
          no-move
          show-remove
          can-be-reset
          @remove-block="containerGradient.model = undefined"
          @reset="containerGradient.reset"
        >
          <menu-content-container border-full :padding-left-right="8">
            <TGradient v-model="containerGradient.model" />
          </menu-content-container>
        </TTabsToggle>
      </content-row>
      <content-row :margin-bottom="16">
        <t-note>{{ $t("layout.background_gradient_text") }}</t-note>
      </content-row>
    </menu-content-container>
  </TTabsToggle>
</template>

<script setup lang="ts">
  import colorPicker from "@/forms/elements/colorPicker.vue";
  import TGradient from "@/components/TGradient/TGradient.vue";
  import { useBlockAttr } from "@/composables/useBlockAttr";
  import { TTabsToggle, TInputNumber, TButton, TNote } from "@topol/twig-ui";

  const { px, str, nullable, anyChanged } = useBlockAttr({
    mode: "global",
    block: "mj-spacer",
  });

  const height = px("height", 50);
  const containerBgColor = str("container-background-color", "");
  const containerGradient = nullable("container-gradient");

  const wasChanged = anyChanged(height, containerBgColor, containerGradient);
</script>
